import React from 'react';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import CustomBootstrapTable from '../CustomBootstrapTable';
import classNames from 'classnames'
import CheckboxFilter from '../CheckBoxFilter';
import RangeFilter from '../RangeFilter';
import moment from 'moment';

function getCustomFilter(filterHandler, customFilterParameters) {
    return (
      <CheckboxFilter
      filterHandler={ filterHandler }
      textOK={ customFilterParameters.textOK }
      />
    );
}

function _getCustomFilter(filterHandler) {
    return (
      <RangeFilter
      filterHandler={ filterHandler }
      />
    );
}

function sortRole(a, b, order) {
    a = `${a.role.includes('admin')}`;
    b = `${b.role.includes('admin')}`;
    if (order === "desc") {
        return a.localeCompare(b);
    } else {
        return b.localeCompare(a);
    }
 }
function sortDate(a, b, order) {
    if (order === 'desc') {
        if (moment(a.lastOnline) < moment(b.lastOnline)) return 1;
        if (moment(a.lastOnline) > moment(b.lastOnline)) return -1;
    } else {
        if (moment(b.lastOnline) < moment(a.lastOnline)) return 1;
        if (moment(b.lastOnline) > moment(a.lastOnline)) return -1;
    }
    return 0;
}

function generateFilters(col, props) {
    if (col.dataField === 'online') {
        return {type: 'CustomFilter', getElement: _getCustomFilter, customFilterParameters: {}}
    } else if (props.customizedColumn && col.dataField) {
        return {type: 'TextFilter', delay: 500, placeholder: col.title }
    } else if (col.dataField === 'status' && props.title !== 'Locked users') {
        return { type: 'CustomFilter', getElement: getCustomFilter, customFilterParameters: { textOK: 'Active' } }
    }
}

function generateSort(col) {
    if (col.dataField === 'online') {
        return sortDate;
    } else if (col.dataField === 'admin') {
        return sortRole;
    }
}

function generateColumns(columns, props) {
    return columns.map(col => {
        const colAttrs = Object.assign(
            {
                isSortable: false,
                isKey: false,
                width: null,
                dataSort: props.customizedColumn && col.dataField ? props.customizedColumn : false,
                filter: generateFilters(col, props),
                filterFormatted: col.dataField !== 'status' && true,
                sortFunc: generateSort(col),
                className: props.title === 'Brokers' ? 'brokerlist' :'',
            },
            col
        );

        return (
            <TableHeaderColumn
                key={uuidv1()}
                {...colAttrs}
            >
                {colAttrs.dataField === 'status' && props.title !== 'Locked users' ? <p className = {classNames({'userstatus': props.title !== 'Brokers' }, {'brokerstatus': props.title === 'Brokers' })}>{col.title}</p>: col.title}
            </TableHeaderColumn>
        );
    });
}

function renderPaginationShowTotal(start, to, total) {
    const items = total === 1 ? 'item' : 'items';
    return (
        <p className="pagination-total">
            Showing {start}-{to} of {total} {items}
        </p>
    );
}

function TableComponent(props) {
    const options = Object.assign(
        {
            sizePerPageList: [],
            paginationShowsTotal: renderPaginationShowTotal
        },
        props.options
    );
    const padTop = props.title.includes('Locked users')
    return (
        <div className={classNames("tableComponent", {'padTop': padTop }, {'brokerlist': props.title === 'Brokers'})}>
            <h1>{props.title}</h1>

            <div className="table">
                <CustomBootstrapTable
                    data={props.data}
                    bordered={false}
                    options={options}
                    pagination={true}
                    search
                    multiColumnSearch
                >
                    {generateColumns(props.columns, props)}
                </CustomBootstrapTable>
            </div>
        </div>
    );
}

TableComponent.propTypes = {
    title: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    options: PropTypes.object,
    data: PropTypes.array
};

export default TableComponent;
